import { useCallback, useEffect, useMemo, useReducer, useState } from "react";
import {
  DropAreaType,
  DropPointTarget,
  DragableItemPosition,
} from "../utils/types";
import { ACTIONS, DropsArea, TOTAL_TIME, useScore } from "../utils/constants";
import DragableItem from "./DragableItem";
import DropArea from "./DropArea";
import HintImage from "../assets/images/hint-image.jpg";
import { Navigate, useNavigate } from "react-router-dom";
import WrongAudio from "../assets/sounds/wrong.mp3";
import { updateUserData } from "../utils/firebase-service";
import Header from "./Header";

export default function BotoxInjectionGame() {
  const navigate = useNavigate();
  const [hintVisbility, setHintVisability] = useState<boolean>(false);
  const [areas, setAreas] = useState<DropAreaType[]>(DropsArea);
  const [botoxCount, setBotoxCount] = useState<number>(0);
  const [time, setTime] = useState<number>(0);
  const [resetGameCount, setResetGameCount] = useState<number>(0);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [successInCurrentArea, setSuccessInCurrentArea] = useState<string[]>([]);
  const [dragableItemPosition, setDragableItemPosition] =
    useState<DragableItemPosition>({
      x: 0,
      y: 0,
    });
  const { dispatch, score, code, gameChecked, gameTarget } = useScore();

  const resetCounter = () => {
    setBotoxCount((_) => 0);
  };

  const handleAreaSuccess = (key: string) => {
    setSuccessInCurrentArea((prev) => [...prev, key]);

  };

  const goToResult = async () => {
    await updateUserData({ code: code || '', score, duration: time });
    navigate("/result", { replace: true });
  }

  const resetGame = () => {
    resetCounter();
    dispatch({ type: ACTIONS.RESET });
    setResetGameCount((prevCount: number) => prevCount + 1);
    setTime((time: number) => 0);
    setActiveIndex(0);
    setSuccessInCurrentArea([]);
  };

  const timeFormat = useMemo(() => {
    const completerdSeconds = parseInt(time / 60 + "");
    const fractions = parseInt((time % 60) + "");
    return ` ${String(completerdSeconds).padStart(2, "0")}:${String(
      fractions
    ).padStart(2, "0")}`;
  }, [time]);

  useEffect(() => {
    const duration = 1000;
    const interval = setInterval(() => {
      setTime((time: number) => {
        return time + 1;
      });
    }, duration);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (successInCurrentArea.length >= areas[activeIndex]?.successCount) {
      goToResult()
      setSuccessInCurrentArea([]);
    }
  }, [successInCurrentArea])



  if (!code) {
    return <Navigate to={"/"} />;
  }
  return (
    <>
      {activeIndex <= 2 && <Header />}
      <section
        className={"game-container" + (areas[activeIndex]?.className ? ` ${areas[activeIndex].className}` : "")}
        onDrag={(e) => {
          setDragableItemPosition((_) => ({ x: e.clientX, y: e.clientY }));
        }}
        onDragEnd={() => {
          setDragableItemPosition({ x: 0, y: 0 });
        }}
        onTouchMove={(e: any) => {
          const touch = e.touches[0];
          setDragableItemPosition((_) => ({
            x: touch.clientX,
            y: touch.clientY,
          }));
        }}
      >

        <article className="draggable-item-container">
          {areas[activeIndex] && (
            <>
              {/* <header>{areas[activeIndex].draggingArea.headerText}</header> */}
              {/* <img className="title-img" src={areas[activeIndex].draggingArea.titleSrc} /> */}
              {areas[activeIndex].draggingArea.options.length > 0 &&
                areas[activeIndex].draggingArea.options.map((option) => (
                  <DragableItem
                    hide={successInCurrentArea.includes(option.value)}
                    key={option.key}
                    imgSrc={option.imageSrc}
                    {...{
                      dragableItemValue: option.value,
                      setBotoxCount,
                      dragableItemPosition,
                      hintVisbility,
                      setHintVisability,
                      resetGame,
                    }}
                  />
                ))}
            </>
          )}
        </article>
        <article className="droppable-areas-container">
          {areas.map((area: DropAreaType, index: number) => (
            <DropArea
              key={area.key}
              {...{
                points: area.points,
                target: area.points.length * DropPointTarget,
                initialImage: area.initialImage,
                targetImage: area.targetImage,
                resetCounter,
                isActive: index === activeIndex,
                onSuccess: (key: string) => setTimeout(() => handleAreaSuccess(key), 0),
              }}
            />
          ))}

          <p className="timer"> {timeFormat} </p>
        </article>

      </section>
    </>
  );
}